"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEMPLATE_TYPE = exports.ARR_TEMPLATE_TYPE = exports.ARR_COLUMN_SPAN = void 0;
var TEMPLATE_TYPE = {
  PRODUCT_CARD: 'productCard',
  PRODUCT_CATEGORY: 'productCategory',
  PRODUCT_GALLERY: 'GalleryCard',
  VERTICAL_CONTENT_CARD: 'VerticalContentCard',
  SNAP_CARD: 'snapCard',
  HOTEL_CARD: 'hotelCard',
  SHOPPING_PRODUCT_CARD: 'shoppingProductCard',
  HOTELS_CROSS_SELL_CARD: 'hotelsCrossSellCard'
};
exports.TEMPLATE_TYPE = TEMPLATE_TYPE;
var ARR_TEMPLATE_TYPE = Object.values(TEMPLATE_TYPE);
exports.ARR_TEMPLATE_TYPE = ARR_TEMPLATE_TYPE;
var ARR_COLUMN_SPAN = ['2', '3', '4', '1'];
exports.ARR_COLUMN_SPAN = ARR_COLUMN_SPAN;